import { ErrorSidePanel } from '@/components/errors';
import { type AssociationType } from '@/portal-api.definition';
import { templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { type SwitchServicesProps } from './-model/props';
import { SwitchServicesLight } from './-skins';
import { type HolderInputState } from './-model/flow';

export const Route = createFileRoute('/(services)/services/_sheet/switch-services/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const navigate = useNavigate();

  function onSelectAssociationType(type: AssociationType) {
    const state: HolderInputState = { associationType: type };
    navigate({ to: '/services/switch-services/holder-input', state });
  }

  const props: SwitchServicesProps = { onSelectAssociationType };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: SwitchServicesProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <SwitchServicesLight {...props} />,
  };
}
